import gql from 'graphql-tag'


export const SEE_REQUESTUSER_TOPCOMMENT = gql`
         query seeRequestUserTopComment {
           seeRequestUserTopComment {
             id
             topCommentId
             textOriginal
             category {
               id
               categoryCount
             }
           }
         }
       `;